import {HeaderTitle} from "../../../../common/HeaderTitle.jsx";
import {SimpleTable} from "../../../../common/simpleTable/SimpleTable.jsx";
import {useKonfiguracja} from "../../../../../api/domain/konfiguracja/queries/useKonfiguracja.jsx";
import {tableKonfiguracjaColumns} from "../lib/columns/tableKonfiguracjaColumns.js";
import ButtonWithIcon from "../../../../common/ButtonWithIcon.jsx";
import {Icons} from "../../../../common/Icons.jsx";
import {LinkContainer} from "react-router-bootstrap";

const ViewListaKonfiguracji = () => {
    const titleName = 'Zarządzanie konfiguracją'

    const konfiguracja = useKonfiguracja()

    const td = (row) => {
        return <td>
            <div className='d-flex gap-1'>
                <LinkContainer to={`/oper/konfiguracja/edycja/${row.id}`}>
                    <ButtonWithIcon
                        variant={'primary'}
                        size={'sm'} onClick={() => null}
                        icon={<Icons.edit/>}
                        title='Edytuj konfigurację'/>
                </LinkContainer>
                <ButtonWithIcon
                    variant={'danger'}
                    size={'sm'} onClick={() => null}
                    icon={<Icons.delete/>}
                    title='Usuń konfigurację'/>
            </div>

        </td>
    }

    return (
        <div>
            <>
                <HeaderTitle
                    breadcrumbLinks={[
                        {label: 'Lista dostępnych konfiguracji'},
                    ]}
                    home
                    destination={'/'}
                    size={'fs-3'}
                    nav
                    title={titleName}/>

                <SimpleTable
                    columns={tableKonfiguracjaColumns}
                    addTh={() => <th>Operacje</th>}
                    addTd={td}
                    data={konfiguracja?.data?.list || []}
                />

            </>


        </div>
    );
}
export default ViewListaKonfiguracji